document.addEventListener('DOMContentLoaded',function(){
  var sidebar=document.querySelector('.sidebar');
  var form=document.querySelector('#filter-form');
  if(!sidebar||!form||!document.body.className.includes('template-collection')) return;

  var PRICE_MIN='filter.v.price.gte';
  var PRICE_MAX='filter.v.price.lte';
  var options=[
    {label:'Dovanos iki 15€',max:'15'},
    {label:'Dovanos iki 25€',max:'25'},
    {label:'Dovanos iki 40€',max:'40'},
    {label:'Premium',min:'40'}
  ];

  function currentUrl(){return new URL(window.location.href);}

  function priceMinName(){
    var input=form.querySelector('input[name$="price.gte"],input[name="filter.v.price.gte"]');
    return input ? input.name : PRICE_MIN;
  }

  function priceMaxName(){
    var input=form.querySelector('input[name$="price.lte"],input[name="filter.v.price.lte"]');
    return input ? input.name : PRICE_MAX;
  }

  function optionActive(o){
    var url=currentUrl();
    var min=url.searchParams.get(priceMinName())||'';
    var max=url.searchParams.get(priceMaxName())||'';
    if(o.max) return max===o.max && !min;
    if(o.min) return min===o.min && !max;
    return false;
  }

  function makeUrl(o){
    var url=currentUrl();
    var minParam=priceMinName();
    var maxParam=priceMaxName();

    url.searchParams.delete('page');
    url.searchParams.delete(minParam);
    url.searchParams.delete(maxParam);

    if(!optionActive(o)){
      if(o.min) url.searchParams.set(minParam,o.min);
      if(o.max) url.searchParams.set(maxParam,o.max);
    }

    return url.pathname+(url.search?url.search:'');
  }

  function clearUrl(){
    var url=currentUrl();
    url.searchParams.delete('page');
    url.searchParams.delete(priceMinName());
    url.searchParams.delete(priceMaxName());
    return url.pathname+(url.search?url.search:'');
  }

  function hideNativeFilters(){
    form.querySelectorAll('.fg').forEach(function(group){
      var hasPrice=group.querySelector('input[name$="price.gte"],input[name$="price.lte"],input[name="filter.v.price.gte"],input[name="filter.v.price.lte"]');
      var hasBudgetTags=Array.from(group.querySelectorAll('input[name="filter.p.tag"]')).some(function(input){
        return ['dovanos-iki-15','dovanos-iki-25','dovanos-iki-40','premium'].includes(input.value);
      });
      if(hasPrice || hasBudgetTags){
        group.style.display='none';
        group.setAttribute('data-hidden-native-budget-filter','true');
      }
    });
  }

  function render(){
    hideNativeFilters();
    if(document.querySelector('.budget-filter')) return;

    var activeAny=options.some(optionActive);
    var wrap=document.createElement('div');
    wrap.className='budget-filter';
    wrap.innerHTML='<div class="budget-filter__title"><span>Biudžetas</span></div><p class="budget-filter__hint">Greitai atrinkite dovanas pagal kainą.</p><div class="budget-filter__list"></div>';

    var list=wrap.querySelector('.budget-filter__list');
    options.forEach(function(o){
      var a=document.createElement('a');
      a.className='budget-filter__item'+(optionActive(o)?' is-active':'');
      a.href=makeUrl(o);
      a.innerHTML='<span class="budget-filter__box" aria-hidden="true"></span><span class="budget-filter__label">'+o.label+'</span>';
      list.appendChild(a);
    });

    if(activeAny){
      var clear=document.createElement('a');
      clear.className='budget-filter__clear';
      clear.href=clearUrl();
      clear.textContent='Išvalyti biudžeto filtrą';
      wrap.appendChild(clear);
    }

    form.insertBefore(wrap,form.firstChild);
  }

  render();
});
